/*
 * Custom Hero Carousel
 * Autoplay slideshow for the "Custom Hero" section.
 * Initialises every .custom-hero-carousel on the page and keeps
 * working inside the Shopify theme editor.
 */
(function () {
  if (typeof window === 'undefined') return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SWIPE_THRESHOLD = 40;
  var instances = {};

  function HeroCarousel(root) {
    this.root = root;
    this.track = root.querySelector('.custom-hero__track');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.custom-hero__slide'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.custom-hero__dot'));
    this.prevBtn = root.querySelector('.custom-hero__arrow--prev');
    this.nextBtn = root.querySelector('.custom-hero__arrow--next');
    this.count = this.slides.length;
    this.index = 0;
    this.timer = null;
    this.touchStartX = null;

    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10);
    this.interval = speed && speed > 0 ? speed : 3000;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !prefersReducedMotion;

    if (!this.track || this.count === 0) return;

    root.classList.add('is-loaded');

    if (this.count < 2) {
      this.activate(0);
      return;
    }

    this.bind();
    this.activate(0);
    if (this.autoplay) this.start();
  }

  HeroCarousel.prototype.bind = function () {
    var self = this;

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () { self.go(self.index + 1); });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () { self.go(self.index - 1); });
    }

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.go(i); });
    });

    // Pause autoplay while the visitor is interacting with the hero.
    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.resume(); });
    this.root.addEventListener('focusin', function () { self.stop(); });
    this.root.addEventListener('focusout', function () { self.resume(); });

    // Keyboard navigation when focus is inside the carousel.
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.go(self.index - 1); }
      else if (e.key === 'ArrowRight') { self.go(self.index + 1); }
    });

    // Touch swipe support.
    this.root.addEventListener('touchstart', function (e) {
      self.touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    this.root.addEventListener('touchend', function (e) {
      if (self.touchStartX === null) return;
      var delta = e.changedTouches[0].clientX - self.touchStartX;
      if (delta <= -SWIPE_THRESHOLD) { self.go(self.index + 1); }
      else if (delta >= SWIPE_THRESHOLD) { self.go(self.index - 1); }
      self.touchStartX = null;
    }, { passive: true });

    // Don't advance while the tab is hidden.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { self.stop(); }
      else { self.resume(); }
    });
  };

  HeroCarousel.prototype.activate = function (i) {
    this.index = (i + this.count) % this.count;
    this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';

    for (var s = 0; s < this.slides.length; s++) {
      var isActive = s === this.index;
      this.slides[s].classList.toggle('is-active', isActive);
      if (isActive) {
        this.slides[s].removeAttribute('inert');
      } else {
        this.slides[s].setAttribute('inert', '');
      }
    }

    for (var d = 0; d < this.dots.length; d++) {
      var dotActive = d === this.index;
      this.dots[d].classList.toggle('is-active', dotActive);
      this.dots[d].setAttribute('aria-current', dotActive ? 'true' : 'false');
    }
  };

  // Navigate from a user action: move and restart the autoplay timer.
  HeroCarousel.prototype.go = function (i) {
    this.activate(i);
    this.resume();
  };

  HeroCarousel.prototype.start = function () {
    this.stop();
    var self = this;
    this.timer = window.setInterval(function () {
      self.activate(self.index + 1);
    }, this.interval);
  };

  HeroCarousel.prototype.resume = function () {
    if (this.autoplay && !document.hidden) this.start();
  };

  HeroCarousel.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  function initRoot(root) {
    if (!root || !root.id) return;
    // A re-rendered section keeps its id; drop any stale timer first.
    if (instances[root.id]) instances[root.id].stop();
    instances[root.id] = new HeroCarousel(root);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('.custom-hero-carousel');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor lifecycle.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.custom-hero-carousel') : null;
    if (root && instances[root.id]) {
      instances[root.id].stop();
      delete instances[root.id];
    }
  });

  // Jump to (and pause on) the slide whose block is being edited.
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? e.target.closest('.custom-hero__slide') : null;
    if (!slide) return;
    var root = slide.closest('.custom-hero-carousel');
    var inst = root ? instances[root.id] : null;
    if (!inst) return;
    inst.stop();
    var idx = inst.slides.indexOf(slide);
    if (idx > -1) inst.activate(idx);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var slide = e.target.closest ? e.target.closest('.custom-hero__slide') : null;
    if (!slide) return;
    var root = slide.closest('.custom-hero-carousel');
    var inst = root ? instances[root.id] : null;
    if (inst) inst.resume();
  });
})();
